export const LEASING_CROSS_VISITS_REPORTING_OBJECT_TYPE = 'leasingCrossVisitsREportingObjectType';
